export const APP_NAME = "VehiLink";

export const APP_DESCRIPTION =
  "Reporta y consulta robos, accidentes e infracciones vehiculares en tu ciudad. Comunidad VehiLink para conductores y motociclistas.";
